module.exports = {"question":"Do you have a bonus code? ","hint":"","yes":"Activate","no":"No","placeholder":"Enter promo code","floating":"Your bonus code","expired":"bonus code has expired","invalid":"bonus code doesn't exist","error_hint":"Please try another or continue without bonus code","promocode":"Promocode","title":"Promo code"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/i18next/en/promoCode.json
// module id = 669
// module chunks = 247 1436